module.exports = __webpack_public_path__ + "static/media/arrowswhite.962eff65.png";